import { BrowserRouter, Link, Navigate, Route, Routes } from "react-router-dom";
import { Sentry } from "./sentry";
import { ScrollToTop } from "./components/ScrollToTop";
import { AppVersionFooter } from "./components/AppVersionFooter";
import { EmailGate } from "./components/EmailGate";
import { Avatar } from "./components/Avatar";
import { Discover } from "./components/Discover";
import { HowItWorks } from "./pages/HowItWorks";
import { AttendeeProvider, useAttendees } from "./context/AttendeeContext";

function BootLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center text-slate-400">
      Loading…
    </div>
  );
}

function PublicHome() {
  const { bootstrapping } = useAttendees();
  if (bootstrapping) return <BootLoading />;
  return <EmailGate />;
}

function PrivateRoom() {
  const { me, attendees, bootstrapping, logout } = useAttendees();

  if (bootstrapping) return <BootLoading />;
  if (!me) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen">
      <header className="border-b border-slate-800/80 bg-black/60 backdrop-blur">
        <div className="mx-auto flex max-w-md items-center justify-between gap-4 px-6 py-4">
          <div className="flex items-center gap-3">
            <Avatar attendee={me} size={36} />
            <p className="text-sm text-slate-300">
              <span className="text-slate-500">Hi,</span>{" "}
              {me.firstName || me.fullName}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Link
              to="/"
              className="rounded-lg border border-slate-800 px-3 py-1.5 text-xs text-slate-400 transition hover:border-slate-600 hover:text-slate-200"
            >
              Home
            </Link>
            <button
              type="button"
              onClick={logout}
              className="rounded-lg border border-slate-800 px-3 py-1.5 text-xs text-slate-400 transition hover:border-slate-600 hover:text-slate-200"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>

      <main>
        <Discover me={me} attendees={attendees} />
      </main>
    </div>
  );
}

function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex min-h-screen items-center justify-center p-6 text-center text-slate-300">
          <p>Something went wrong. Refresh the page or sign in again.</p>
        </div>
      }
    >
      <BrowserRouter>
        <ScrollToTop />
        <AttendeeProvider>
          <Routes>
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/room" element={<PrivateRoom />} />
            <Route path="/" element={<PublicHome />} />
          </Routes>
          <AppVersionFooter />
        </AttendeeProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
